import { ClaimModalComponent } from '../claim-modal/claim-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { PolicyDataService } from '../../../../../_services/data-services/policy-data.service';
import { ClaimsService } from '../../../../../_services/_claims/claims.service';
import * as _ from 'underscore';
import { ContactService } from '../../../../../_services/misc-services/contact.service';
import{ NavigationService } from '@services/navigation.service';
import { ActionType } from '@models/widget/action-type.enum';
import { UrlValidationService } from '@services/document/url-validation.service';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, ClaimModalComponent],
  selector: 'app-claims-report',
  templateUrl: './claims-report.component.html',
  styleUrls: ['./claims-report.component.scss'],
})
export class ClaimsReportComponent implements OnInit {
  policies: any = [];
  policyType: any;
  livoNumber = false;
  as400Number = false;
  both = false;
  allLivoPolicy: any = [];
  isAcmic: boolean;
  @Input() placement = 'sidebar';
  // exlRedirectPath: string;

  constructor(
    private policyDataService: PolicyDataService,
    private claimsService: ClaimsService,
    private contactService: ContactService,
    private acmicService: AcmicService,
    private navService: NavigationService,
    private urlValidationService: UrlValidationService
  ) { }

  reportClaim(policy, event?: Event) {
    event?.preventDefault();
    this.navService.saveCurrentAction(ActionType.ReportClaim);
    const claimWindow = Capacitor.isNativePlatform() ? null : window.open('', '_blank');

    this.claimsService.reportClaim(policy).subscribe({
      next: (url: string) => {
        if (!this.urlValidationService.isApprovedRedirectUrl(url)) {
          claimWindow?.close();
          return;
        }

        if (Capacitor.isNativePlatform()) {
          Browser.open({ url });
        } else if (claimWindow) {
          claimWindow.location.href = url;
        } else {
          window.open(url, '_blank');
        }
      },
      error: () => {
        claimWindow?.close();
      }
    });
  }


  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    // this.exlRedirectPath = this.isAcmic ? environment.acmicExlRedirectUrl : environment.maExlRedirectUrl;

    this.policyDataService.$policyDetails.subscribe((policies: any) => {
      this.policies = _.filter(policies, (policy) => {
        return new Date(policy.effDate) <= new Date();
      });
      this.policyType = _.keys(
        _.groupBy(
          _.pluck(_.pluck(policies, 'policynumber'), 'policyNumber'),
          'length'
        )
      );

      this.contactService.dynamicContact(policies, this.policyType);
      this.as400Number = this.contactService.as400Number;
      this.livoNumber = this.contactService.livoNumber;
      this.both = this.contactService.both;
      this.allLivoPolicy = this.contactService.allLivoPolicy;
    });
  }
}
